export default __webpack_public_path__ + "static/assets/med_pill_square_out_L1_solid_l_01_f_mask.376bb5b9.png";